(function () {
  var panel = document.querySelector('[data-bm-panel]');
  if (!panel) return;

  var shade = document.querySelector('[data-bm-shade]');
  var wrapper = panel.closest('.header-wrapper') || panel.parentElement;
  var burger = document.querySelector('[data-bm-burger]');
  var openers = Array.prototype.slice.call(document.querySelectorAll('[data-bm-open]'));
  var home = panel.querySelector('[data-bm-home]');
  var views = Array.prototype.slice.call(panel.querySelectorAll('[data-bm-view]'));
  var body = panel.querySelector('[data-bm-body]');
  var stepsEl = panel.querySelector('[data-bm-steps]');
  var qEl = panel.querySelector('[data-bm-q]');
  var metaEl = panel.querySelector('[data-bm-meta]');
  var cta = panel.querySelector('[data-bm-cta]');
  var back = panel.querySelector('[data-bm-back]');
  var ctaText = panel.querySelector('[data-bm-cta-text]');
  var desktop = window.matchMedia('(min-width: 990px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEPS = ['Type', 'Brand', 'Model', 'Year'];
  var QS = ['What do you ride?', 'Which brand?', 'Which model?', 'Which years?'];
  var state = { view: 'bike', step: 0, t: null, b: null, m: null, y: null, opener: null };

  function kids(el) { return el ? Array.prototype.slice.call(el.children) : []; }
  function name(li) { return li.firstElementChild ? li.firstElementChild.textContent.trim() : ''; }
  function sub(li) { return li.lastElementChild && li.lastElementChild.tagName === 'UL' ? li.lastElementChild : null; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var types = kids(panel.querySelector('[data-bm-tree]')).map(function (tl) {
    return { id: tl.dataset.t, name: name(tl), href: tl.dataset.href || '', note: tl.dataset.note || '', brands: kids(sub(tl)).map(function (bl) {
      return { name: name(bl), href: bl.dataset.href || '', fams: kids(sub(bl)).map(function (fl) {
        return { name: name(fl), models: kids(sub(fl)).map(function (ml) {
          return { name: name(ml), groups: kids(sub(ml)).map(function (gl) {
            var a = gl.querySelector('a');
            return { years: a.textContent.trim(), v: a.dataset.v || '', href: a.getAttribute('href') };
          }) };
        }) };
      }) };
    }) };
  });
  panel.classList.add('bm-ready');

  function type() { return types.filter(function (t) { return t.id === state.t; })[0]; }
  function brand() { var t = type(); return t && t.brands.filter(function (b) { return b.name === state.b; })[0]; }
  function model() {
    var b = brand(), hit = null;
    if (b) b.fams.forEach(function (f) { f.models.forEach(function (m) { if (m.name === state.m) hit = m; }); });
    return hit;
  }
  function single(t) { return t && t.brands.length === 1; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  function opt(nm, sb, attrs, i, hl, href) {
    var inner = '<span class="bm-node"></span><span class="bm-lab"><span class="bm-nm">' + esc(nm) + '</span>' +
      (sb ? '<span class="bm-sb' + (hl ? ' bm-sb--hl' : '') + '">' + esc(sb) + '</span>' : '') + '</span><span class="bm-go" aria-hidden="true">→</span>';
    return href
      ? '<a class="bm-opt" style="--i:' + i + '" href="' + esc(href) + '" ' + attrs + '>' + inner + '</a>'
      : '<button type="button" class="bm-opt" style="--i:' + i + '" ' + attrs + '>' + inner + '</button>';
  }

  function picks() {
    var t = type(), b = brand(), m = model();
    return [t ? t.name : '', b ? b.name : '', m ? m.name : '', state.y ? state.y.label : ''];
  }

  function renderSteps() {
    var p = picks(), s = state.step, html = '';
    for (var i = 0; i < 4; i++) {
      var cls = i < s ? 'is-done' : (i === s ? 'is-active' : '');
      var val = i < s ? p[i] : (i === s ? 'Choose…' : '-');
      var skip = i === 1 && single(type());
      html += '<button type="button" class="bm-stp ' + cls + '" data-bm-to="' + i + '"' + (i < s && !skip ? '' : ' tabindex="-1" aria-disabled="true"') +
        '><span class="bm-node"></span><span class="bm-l">0' + (i + 1) + ' ' + STEPS[i] + '</span><span class="bm-v">' + esc(val) + '</span></button>';
    }
    stepsEl.innerHTML = html;
    stepsEl.style.setProperty('--sfill', (Math.min(s + (state.y ? 1 : 0), 4) / 4 * 100) + '%');
  }

  function renderBody() {
    var s = state.step, h = '';
    qEl.textContent = QS[s];
    if (s === 0) {
      metaEl.textContent = plural(types.length, 'category', 'categories');
      h = '<div class="bm-grid">' + types.map(function (t, i) { return opt(t.name, t.note, 'data-bm-t="' + esc(t.id) + '"', i); }).join('') + '</div>';
    } else if (s === 1) {
      var bl = type().brands;
      metaEl.textContent = plural(bl.length, 'brand', 'brands');
      h = '<div class="bm-grid">' + bl.map(function (b, i) { return opt(b.name, '', 'data-bm-b="' + esc(b.name) + '"', i); }).join('') + '</div>';
    } else if (s === 2) {
      var fams = brand().fams, count = 0, k = 0;
      fams.forEach(function (f) { count += f.models.length; });
      metaEl.textContent = plural(count, 'model', 'models');
      h = '<div class="bm-mcols">' + fams.map(function (f, c) {
        return '<div><div class="bm-gl" style="--i:' + c + '"><b>' + esc(f.name) + '</b><span>' + f.models.length + '</span></div>' +
          f.models.map(function (m) { k++; return opt(m.name, '', 'data-bm-m="' + esc(m.name) + '"', c + k); }).join('') + '</div>';
      }).join('') + '</div>';
    } else {
      var gs = model().groups;
      metaEl.textContent = plural(gs.length, 'year range', 'year ranges');
      h = '<div class="bm-grid bm-grid--years">' + gs.map(function (g, i) {
        var label = g.years + (g.v ? ' ' + g.v : '');
        return opt(g.years, g.v ? g.v.replace(/ restyle plastics$/, ' restyle') : 'Original plastics', 'data-bm-y="' + i + '" data-bm-label="' + esc(label) + '"', i, !!g.v, g.href);
      }).join('') + '</div>';
    }
    body.classList.remove('is-in');
    body.innerHTML = h;
    void body.offsetWidth;
    body.classList.add('is-in');
    var sel = s === 0 ? state.t : s === 1 ? state.b : s === 2 ? state.m : null;
    if (sel != null) {
      Array.prototype.forEach.call(body.querySelectorAll('.bm-opt'), function (o) {
        var v = o.dataset.bmT || o.dataset.bmB || o.dataset.bmM;
        if (v === sel) o.classList.add('is-selected');
      });
    }
    renderCta();
  }

  function renderCta() {
    var t = type(), text = '', href = '';
    if (state.step === 1 && t && t.href) { text = 'All ' + t.name.toLowerCase().replace(/s$/, '') + ' graphics'; href = t.href; }
    var b = brand();
    if (state.step === 2 && b && b.href) { text = 'All graphics for ' + b.name; href = b.href; }
    cta.hidden = !href;
    if (href) { cta.setAttribute('href', href); ctaText.textContent = text; }
    back.hidden = state.step === 0;
  }

  function render() { renderSteps(); renderBody(); }

  function advance(fn) {
    if (reduced.matches) { fn(); render(); return; }
    stepsEl.style.setProperty('--sfill', (Math.min(state.step + 1, 4) / 4 * 100) + '%');
    setTimeout(function () { fn(); render(); }, 380);
  }

  function setView(v) {
    state.view = v;
    views.forEach(function (el) { el.hidden = el.dataset.bmView !== v; });
    home.hidden = v === 'root';
    panel.classList.toggle('is-root', v === 'root');
    openers.forEach(function (o) { o.setAttribute('aria-expanded', String(!panel.hidden && o.dataset.bmOpen === v)); });
    if (v === 'bike') render();
    else {
      var vb = panel.querySelector('[data-bm-view="' + v + '"] .bm-body');
      if (v === 'root') state.view = 'root';
      if (vb) { vb.classList.remove('is-in'); void vb.offsetWidth; vb.classList.add('is-in'); }
    }
  }

  function place() {
    var top = Math.max(0, Math.round(wrapper.getBoundingClientRect().bottom));
    panel.style.setProperty('--bm-top', top + 'px');
    if (shade) shade.style.setProperty('--bm-top', top + 'px');
  }

  function open(v, opener) {
    place();
    panel.hidden = false;
    if (shade) shade.hidden = !desktop.matches;
    state.opener = opener || null;
    setView(v);
    if (burger) burger.setAttribute('aria-expanded', 'true');
    if (!desktop.matches) document.body.classList.add('bm-lock');
  }

  function close(refocus) {
    if (panel.hidden) return;
    panel.hidden = true;
    if (shade) shade.hidden = true;
    document.body.classList.remove('bm-lock');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    if (refocus && state.opener) state.opener.focus();
  }

  openers.forEach(function (o) {
    o.addEventListener('click', function () {
      if (!panel.hidden && state.view === o.dataset.bmOpen) { close(true); return; }
      open(o.dataset.bmOpen, o);
    });
  });
  if (burger) burger.addEventListener('click', function () { panel.hidden ? open('root', burger) : close(true); });
  home.addEventListener('click', function () { setView('root'); });
  panel.querySelectorAll('[data-bm-go]').forEach(function (b) { b.addEventListener('click', function () { setView(b.dataset.bmGo); }); });
  panel.querySelector('[data-bm-close]').addEventListener('click', function () { close(true); });
  if (shade) shade.addEventListener('click', function () { close(false); });

  body.addEventListener('click', function (e) {
    var o = e.target.closest('.bm-opt');
    if (!o) return;
    var d = o.dataset;
    Array.prototype.forEach.call(body.querySelectorAll('.bm-opt'), function (x) { x.classList.toggle('is-selected', x === o); });
    if (d.bmT) {
      advance(function () {
        state.t = d.bmT; state.b = null; state.m = null; state.y = null;
        if (single(type())) { state.b = type().brands[0].name; state.step = 2; } else state.step = 1;
      });
    } else if (d.bmB) {
      advance(function () { state.b = d.bmB; state.m = null; state.y = null; state.step = 2; });
    } else if (d.bmM) {
      advance(function () { state.m = d.bmM; state.y = null; state.step = 3; });
    } else if (d.bmY != null) {
      stepsEl.style.setProperty('--sfill', '100%');
    }
  });

  function goBack() {
    var n = state.step - 1;
    if (n === 1 && single(type())) n = 0;
    if (n < 0) return;
    if (n <= 0) { state.t = null; state.b = null; }
    if (n <= 1) state.b = null;
    state.m = null; state.y = null; state.step = n;
    render();
    var first = body.querySelector('.bm-opt.is-selected') || body.querySelector('.bm-opt');
    if (first && document.activeElement === back) first.focus({ preventScroll: true });
  }
  back.addEventListener('click', goBack);

  stepsEl.addEventListener('click', function (e) {
    var b = e.target.closest('.bm-stp.is-done');
    if (!b || b.getAttribute('aria-disabled') === 'true') return;
    var n = +b.dataset.bmTo;
    if (n <= 0) { state.t = null; state.b = null; }
    if (n <= 1) state.b = null;
    state.m = null; state.y = null; state.step = n;
    render();
  });

  panel.querySelectorAll('.bm-grid--designs .bm-opt, .bm-grid--info .bm-opt').forEach(function (o) {
    o.addEventListener('click', function () {
      Array.prototype.forEach.call(o.parentElement.children, function (x) { x.classList.toggle('is-selected', x === o); });
    });
  });

  var fetched = {};
  function prefetch(e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !panel.contains(a)) return;
    var href = a.getAttribute('href');
    if (!href || fetched[href] || href.charAt(0) !== '/') return;
    fetched[href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    document.head.appendChild(l);
  }
  panel.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
    a.classList.add('is-selected');
    panel.classList.add('is-leaving');
  });
  window.addEventListener('pageshow', function () { panel.classList.remove('is-leaving'); });
  panel.addEventListener('pointerover', prefetch, { passive: true });
  panel.addEventListener('touchstart', prefetch, { passive: true });
  panel.addEventListener('focusin', prefetch);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
  window.addEventListener('resize', function () { if (!panel.hidden) place(); });
  var onChange = function () { close(false); };
  if (desktop.addEventListener) desktop.addEventListener('change', onChange); else desktop.addListener(onChange);
})();
